import { useEffect, useState } from "react";
import moment from "moment/moment";
import { useDispatch, useSelector } from "react-redux";

import { KanbanStageJobStatus } from "./stage.job.status";
import { fetchOpenJobServices } from "../../stores/jobs";
import {
  ENUM_JOB_STATUS_JOB_COMPLETED_PAY_PENDING,
  ENUM_JOB_STATUS_JOB_INIT,
  ENUM_JOB_STATUS_JOB_NAV_CREATED,
  ENUM_JOB_STATUS_JOB_NAV_INPROGRESS,
  ENUM_JOB_STATUS_JOB_WORK_INPROGRESS,
  ENUM_JOB_STATUS_TECH_ASSIG,
} from "../../utilities";

const STAGE_WAIT_TECH_ENUM = "Finding Partner";
const STAGE_WAUT_ACTI_ENUM = "Pending Partner Action";
const STAGE_NAV_PREMI_ENUM = "Navigate to Premise";
const STAGE_PEND_WORK_ENUM = "Working";
const STAGE_PEND_PAYM_ENUM = "Pending Payment Transfer";
const STAGE_ESCALATION_ENUM = "Escalation";

export const KanbanBoardJobs = () => {
  const dispatch = useDispatch();
  const {
    is_first_loading,
    items = [],
    next_token = null,
  } = useSelector((context) => context.jobs);

  const [, setTimer] = useState(0);

  useEffect(() => {
    if (!next_token) return;

    console.log("kanban.board.jobs", "load more data");
    dispatch(fetchOpenJobServices({ next_token }))
      .unwrap()
      .catch((err) => {
        console.error("kanban.board.jobs", "loadData", err);
      });
  }, [dispatch, next_token]);

  useEffect(() => {
    if (!is_first_loading) return;

    console.log("kanban.board.jobs", "load 1st data");
    dispatch(fetchOpenJobServices({ next_token: null }));
  }, [dispatch, is_first_loading]);

  useEffect(() => {
    const timerId = setInterval(() => {
      setTimer(Date.now());
    }, 1000 * 60);

    return () => clearInterval(timerId);
  }, []);

  const hasEscalated = (job) => {
    const isUrgentBreakdown =
      job.service_type === "faulty" && job.schedule?.type === "immediate";

    if (!isUrgentBreakdown) return false;

    const statusesBeforeGoNow = [
      ENUM_JOB_STATUS_TECH_ASSIG,
      ENUM_JOB_STATUS_JOB_INIT,
      ENUM_JOB_STATUS_JOB_NAV_CREATED,
    ];

    if (!statusesBeforeGoNow.includes(job.status)) return false;
    if (!job.technician_lookup_starttime) return false;

    const minutesSincePayment = moment().diff(
      moment(job.technician_lookup_starttime),
      "minutes",
    );

    return minutesSincePayment >= 60;
  };

  return (
    <div className="flex w-full gap-4 overflow-x-auto pb-4">
      <KanbanStageJobStatus
        key="escalation"
        title={STAGE_ESCALATION_ENUM}
        jobs={items.filter(hasEscalated)}
        escalated
      />

      <KanbanStageJobStatus
        key="finding-partner"
        title={STAGE_WAIT_TECH_ENUM}
        jobs={items.filter(
          (item) =>
            item.status === ENUM_JOB_STATUS_TECH_ASSIG &&
            !hasEscalated(item),
        )}
      />

      <KanbanStageJobStatus
        key="pending-partner-action"
        title={STAGE_WAUT_ACTI_ENUM}
        jobs={items.filter(
          (item) =>
            [
              ENUM_JOB_STATUS_JOB_INIT,
              ENUM_JOB_STATUS_JOB_NAV_CREATED,
            ].includes(item.status) && !hasEscalated(item),
        )}
      />

      <KanbanStageJobStatus
        key="navigate-to-premise"
        title={STAGE_NAV_PREMI_ENUM}
        jobs={items.filter(
          (item) =>
            item.status === ENUM_JOB_STATUS_JOB_NAV_INPROGRESS,
        )}
      />

      <KanbanStageJobStatus
        key="working"
        title={STAGE_PEND_WORK_ENUM}
        jobs={items.filter(
          (item) => item.status === ENUM_JOB_STATUS_JOB_WORK_INPROGRESS,
        )}
      />

      <KanbanStageJobStatus
        key="pending-payment-transfer"
        title={STAGE_PEND_PAYM_ENUM}
        jobs={items.filter(
          (item) => item.status === ENUM_JOB_STATUS_JOB_COMPLETED_PAY_PENDING,
        )}
      />
    </div>
  );
};
